import {FC, useEffect, useState} from 'react';
import {Box, Button, TextField, Typography,} from '@mui/material';
import {FormattedMessage, useIntl} from 'react-intl';
import AMPModal from 'src/components/common/AMPModal';
import {UpdateBexioIdModalProps} from './UpdateBexioIdModal.types';

export const UpdateBexioIdModal: FC<UpdateBexioIdModalProps> = ({
                                                                    open,
                                                                    onClose,
                                                                    onUpdate,
                                                                    currentBexioId,
                                                                }) => {
    const intl = useIntl();
    const [bexioId, setBexioId] = useState<string>('');

    useEffect(() => {
        if (open) {
            setBexioId(currentBexioId?.toString() || '');
        }
    }, [open, currentBexioId]);

    const handleSubmit = () => {
        const numericBexioId = bexioId ? parseInt(bexioId, 10) : undefined;
        if (!bexioId || numericBexioId === undefined || numericBexioId <= 0) {
            return;
        }
        onUpdate(numericBexioId);
        onClose();
    };

    const handleClose = () => {
        setBexioId('');
        onClose();
    };

    const handleBexioIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Allow only numbers or empty string
        if (value === '' || /^\d+$/.test(value)) {
            setBexioId(value);
        }
    };

    return (
        <AMPModal
            open={open}
            handleClose={handleClose}
            title={intl.formatMessage({id: 'updateBexioId'})}
            type="sm"
            fullWidth
        >
            <Box sx={{p: 3}}>
                <Typography variant="body2" sx={{mb: 2}}>
                    <FormattedMessage id="updateUserBexioIdDescription"/>
                </Typography>

                <TextField
                    fullWidth
                    label={intl.formatMessage({id: 'bexioId'})}
                    value={bexioId}
                    onChange={handleBexioIdChange}
                    variant="outlined"
                    sx={{
                        mb: 3,
                        '& .MuiInputLabel-root': {
                            '&.Mui-focused': {
                                backgroundColor: 'white',
                                px: 0.5,
                            },
                            '&.MuiInputLabel-shrink': {
                                backgroundColor: 'white',
                                px: 0.5,
                            }
                        }
                    }}
                    placeholder={intl.formatMessage({id: 'enterBexioId'})}
                    required
                    error={bexioId !== '' && (!bexioId || parseInt(bexioId, 10) <= 0)}
                    helperText={bexioId !== '' && (!bexioId || parseInt(bexioId, 10) <= 0) ? 'Bexio ID must be greater than 0' : ''}
                    inputProps={{
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                    }}
                />

                <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 2}}>
                    <Button variant="outlined" onClick={handleClose}>
                        <FormattedMessage id="cancel"/>
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!bexioId || parseInt(bexioId, 10) <= 0}
                    >
                        <FormattedMessage id="update"/>
                    </Button>
                </Box>
            </Box>
        </AMPModal>
    );
};